'use client';

import { useProgress } from '@bprogress/next';
import { useEffect } from 'react';

const NON_NAVIGABLE_HREF = /^(tel|mailto|blob|javascript):/;

export function AnchorProgress() {
  const { start } = useProgress();

  useEffect(() => {
    const onClick = (event: MouseEvent) => {
      if (event.defaultPrevented || event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      const anchor = (event.target as Element | null)?.closest?.('a');
      if (!anchor || typeof anchor.href !== 'string' || anchor.hasAttribute('download')) return;
      if (anchor.target === '_blank') return;
      if (anchor.getAttribute('data-disable-progress') === 'true') return;
      if (anchor.closest('[data-prevent-progress="true"]')) return;
      if (!anchor.href || NON_NAVIGABLE_HREF.test(anchor.href)) return;

      const targetUrl = new URL(anchor.href, window.location.href);
      if (targetUrl.origin === window.location.origin && targetUrl.pathname === window.location.pathname) return;

      start();
    };

    document.addEventListener('click', onClick, true);
    return () => document.removeEventListener('click', onClick, true);
  }, [start]);

  return null;
}
